import { render } from "./ChatInputAssignOverlay.vue?vue&type=template&id=278a5290&scoped=true&ts=true"
import script from "./ChatInputAssignOverlay.vue?vue&type=script&lang=ts"
export * from "./ChatInputAssignOverlay.vue?vue&type=script&lang=ts"

import "./ChatInputAssignOverlay.vue?vue&type=style&index=0&id=278a5290&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-278a5290"]])

export default __exports__